const AboutSection = () => (
  <section className="about-section" data-testid="about-section">
    <div className="about-content">
      <h3 className="about-title">About</h3>
      <p className="about-text" data-testid="description">
        Verum Inventa advises a private group of companies with operations in London, Delaware and Nairobi. The group is focused on developing impactful assets and ventures across scientific, geological, educational and sports infrastructure sectors. Its approach combines commercial discipline with social purpose, supporting projects that encourage enterprise, innovation and environmentally responsible solutions for the long-term benefit of communities and stakeholders.
      </p>
    </div>
  </section>
);

export default AboutSection;
